/**
 * 完了チェック（ゴール機能・停止ゲート）結果の型定義とユーティリティ
 *
 * desktop-app / web の両パッケージで共通利用する。合成チャンク
 * `builtin__completionCheck` の tool-result ペイロード（表示用）の形を表す。
 */
/**
 * タスク履歴で完了チェッカーの作業に付ける担当名。
 * チェッカーの作業はサブエージェントの作業と同じ形式で、完了チェックの項目の下に並ぶ。
 */
export const COMPLETION_CHECKER_AGENT_NAME = '完了チェッカー';
/** 要確認の分類の表示名 */
export const UNVERIFIABLE_CATEGORY_LABELS = {
    unreadable: '読み取れない',
    runtime: '動作の確認が必要',
    external: '外部の事情',
    'tool-failure': 'ツールの失敗',
};
/** 完了チェック結果の構造を検証する型ガード */
export function isCompletionCheckResult(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const v = value;
    return ((v.verdict === 'met' || v.verdict === 'unmet' || v.verdict === 'unverifiable') &&
        Array.isArray(v.criteria) &&
        Array.isArray(v.unmetReasons));
}
//# sourceMappingURL=completion-check-result.js.map